import { createApi } from "@reduxjs/toolkit/query/react";
import { fetchQuery } from "../helpers/ApiHelpers";

export enum MutualFundTags {
  MutualFund = "mutual-fund",
}

export const baseApi = createApi({
  reducerPath: "api",

  baseQuery: fetchQuery(),
  tagTypes: [MutualFundTags.MutualFund, "Profile", "Documents", "NewInfoUser"],
  endpoints: (builder) => ({}),
});
